import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonGrid, IonRow, IonCol, IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonIcon } from '@ionic/react';
import { IonSearchbar, IonFab, IonFabList, IonFabButton, IonList, IonItem, IonButtons, IonBackButton, IonAvatar, IonLabel } from '@ionic/react';
import './openorders.css';
import { people, add } from 'ionicons/icons'
import getApi from '../../api';
import EnvironmentBadge from '../../components/EnvironmentBadge';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router';
import { useLocalStorage } from '../../components/useLocalStorage'
import { useIonViewDidEnter } from '@ionic/react';
import { useHistory } from "react-router-dom";

const OpenOrders: React.FC = () => {
    const [openOrders, setOpenOrders] = useState([]);
    const history = useHistory();
    const api = getApi();

    
    useIonViewDidEnter(() => {
      const fetchData = async () => {
        try {
          const response = await api.get('/fortnox/v2/orders/?tosend=true');
          console.log(response.data.Orders);
          setOpenOrders(response.data.Orders || []); // Ensure Orders is an array
        } catch (error) {
          console.error("Failed to fetch open orders:", error);
          // Optionally set an empty array or display an error message to the user
          setOpenOrders([]);
          fetchData(); // Retry fetching data on error
          
        }
      };
  
      fetchData();
    });

    
    
    return (
        <IonPage placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <IonHeader placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonToolbar color="primary" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonButtons slot="start" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                      <IonBackButton />
                    </IonButtons>
            <IonTitle placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>Öppna ordrar</IonTitle>
            <div slot="end" style={{paddingRight:'8px'}}><EnvironmentBadge /></div>
            </IonToolbar>
        </IonHeader>
        <IonContent fullscreen placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonList placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            {openOrders.map((order: any) => (
                <IonItem key={order.DocumentNumber} routerLink={"/Order/" + order.DocumentNumber} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <IonLabel placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <h2>{order.CustomerName}</h2>
                    <p>Ordernummer: {order.DocumentNumber}</p>
                    <p>Orderdatum: {order.OrderDate}</p>
                    <p>Skickad: {order.Sent === true && "Ja"}{order.Sent === false && "Nej"}</p>
                    {order.Sent === true && <p>Skickades: {order.DeliveryDate}</p>}
                </IonLabel>
                </IonItem>
            ))}
            </IonList>
        </IonContent>
        </IonPage>
    );
    }

export default OpenOrders;